import { AnimatePresence, motion } from "framer-motion";
import { createPortal } from "react-dom";
import images from "./../../images";

const OpacityPage = (props) => {
  const {
    isOpen,
    children,
    backgroundColor = "#ECEEFF",
    className = "",
    isHeaderVisible = false,
  } = props;

  // Khi không mở → trả về null để AnimatePresence biết phải chạy exit
  if (!isOpen && typeof document === "undefined") return null;

  const content = (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className={`fixed inset-0 z-50 flex items-center justify-center transition-colors duration-700 ease-in-out overflow-auto ${className}`}
            style={{ backgroundColor }}
          >
            {isHeaderVisible && (
              <img
                src={images.v6Logo}
                alt="Rally Logo"
                className="w-[100px] h-[11px] object-contain absolute top-[60px] max-xs:hidden"
              />
            )}
            {children}
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );

  return createPortal(content, document.body);
};

export default OpacityPage;
